import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { BUSINESS } from '../../mocks/sharedData';

interface MidPageCTAProps {
  headline?: string;
  subtext?: string;
  cta?: string;
  ctaHref?: string;
}

const MidPageCTA = ({
  headline = 'Find Out How Much You Can Save',
  subtext = 'Take 60 seconds. Get a custom solar savings estimate — zero obligation.',
  cta = 'Schedule Your Free Consultation',
  ctaHref,
}: MidPageCTAProps) => {
  const { ref, isVisible } = useScrollAnimation();
  const href = ctaHref || BUSINESS.consultationUrl;

  return (
    <section className="relative overflow-hidden">
      {/* BG image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/304c51e042182e2d070c0553cd5abfdf.jpg"
          alt="Solar neighborhood"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/97 via-zinc-950/90 to-zinc-950/70" />
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-7xl mx-auto px-6 py-20 flex flex-col lg:flex-row items-center justify-between gap-10 transition-all duration-800 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Left */}
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-amber-500" />
            <span className="text-amber-400 text-xs font-semibold tracking-[0.2em] uppercase">
              Limited Time — 30% Federal Tax Credit
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-white leading-tight mb-4">
            {headline}
          </h2>
          <p className="text-zinc-400 text-lg">{subtext}</p>
        </div>

        {/* Right — CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold text-sm px-9 py-5 rounded-full whitespace-nowrap transition-all duration-300 cursor-pointer tracking-wide"
          >
            {cta}
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </a>
          <a
            href={BUSINESS.phoneTel}
            className="inline-flex items-center justify-center gap-3 border-2 border-white/30 hover:border-amber-400 hover:text-amber-400 text-white font-semibold text-sm px-7 py-5 rounded-full whitespace-nowrap transition-all duration-300 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill" />
            </div>
            {BUSINESS.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
